import React, { Component } from 'react';
import classNames from 'classnames/bind';
import legacyEventHub from '~/modules/legacyRuntime.js';
// // import $ from 'jquery';
import confetti from 'canvas-confetti';
import ahoy from 'ahoy.js';

import UsageLicenseTypeSelect from '~/components/legacy/UsageLicenseTypeSelect.jsx';
import { buildProjectLicenseCartRequestData, buildProjectLicenseCartRemoveRequestData, buildProjectLicenseTrackingProps } from '~/components/legacy/projectLicenseCartSelection.js';
import { trackCatalogEvent, withRankingPayload } from '~/modules/catalogEventTracking.js';
import { requestJson } from '~/modules/legacyRequest.js';
import TrackDetailsDrawer from '~/components/legacy/TrackDetailsDrawer.jsx';
import SimilarTracksDrawer from '~/components/legacy/SimilarTracksDrawer.jsx';
import TrackWaveformPlayer from '~/components/legacy/TrackWaveformPlayer.jsx';
import ProjectAddTo from '~/components/legacy/ProjectAddTo.jsx';
import { energyBarCountFromPercent, energyPercentFromTrack } from '~/components/legacy/trackEnergy.js';

const MIN_DEMO_DOWNLOAD_LENGTH_SECONDS = 15;

class Track extends Component {

  // mixins : [UsageLicenseTypeSelectMixin],

  constructor(props) {
    super(props)

    this.handleClick = this.handleClick.bind(this);
    this.handleLayoutDownloadClick = this.handleLayoutDownloadClick.bind(this);
    this.handleShareClick = this.handleShareClick.bind(this);
    this.handlefreeDownloadBuyInShopClick = this.handlefreeDownloadBuyInShopClick.bind(this);
    this.handlefreeDownloadAgreeClick = this.handlefreeDownloadAgreeClick.bind(this);
    this.handleNextClick = this.handleNextClick.bind(this);
    this.handlePrevClick = this.handlePrevClick.bind(this);
    this.handleFavoriteClick = this.handleFavoriteClick.bind(this);
    this.handleFreeDownloadClick = this.handleFreeDownloadClick.bind(this);
    this.handleMouseEnter = this.handleMouseEnter.bind(this);
    this.handleMouseLeave = this.handleMouseLeave.bind(this);
    this.handleVariantClick = this.handleVariantClick.bind(this);
    this.toggleMatchingVariants = this.toggleMatchingVariants.bind(this);
    this.toggleMobileVariants = this.toggleMobileVariants.bind(this);
    this.handleCartClick = this.handleCartClick.bind(this);
    this.handleProScopeClick = this.handleProScopeClick.bind(this);
    this.openTrackDetailsDrawer = this.openTrackDetailsDrawer.bind(this);
    this.closeTrackDetailsDrawer = this.closeTrackDetailsDrawer.bind(this);
    this.openSimilarTracksDrawer = this.openSimilarTracksDrawer.bind(this);
    this.closeSimilarTracksDrawer = this.closeSimilarTracksDrawer.bind(this);
    this.handleUsageLicenseTypeSelectClose = this.handleUsageLicenseTypeSelectClose.bind(this);
    this.updateProjectLicenseFamily = this.updateProjectLicenseFamily.bind(this);
    this.removeProjectLicenseSelection = this.removeProjectLicenseSelection.bind(this);
    this.updateCart = this.updateCart.bind(this);
    this.trackDetailsHref = this.trackDetailsHref.bind(this);
    this.gemaNavigatorHref = this.gemaNavigatorHref.bind(this);
    this.eventHubListeners = [];

    this.state = {
      playing : false,
      isHovered : false,
      showUsageLicenseSelect: false,
      matchingVariantsExpanded: this.matchingVariantsForProps(props).length > 0,
      mobileVariantsExpanded: false,
      showTrackDetailsDrawer: false,
      showSimilarTracksDrawer: false
    }
  }

  componentDidUpdate(prevProps) {
      if (
        prevProps.id !== this.props.id ||
        prevProps.minLengthFilter !== this.props.minLengthFilter ||
        prevProps.maxLengthFilter !== this.props.maxLengthFilter ||
        prevProps.loopFilter !== this.props.loopFilter ||
        prevProps.track_variants !== this.props.track_variants
      ) {
        const hasMatchingVariants = this.matchingVariantsForProps(this.props).length > 0;

        if (
          this.state.matchingVariantsExpanded !== hasMatchingVariants ||
          this.state.mobileVariantsExpanded !== false
        ) {
          this.setState({
            matchingVariantsExpanded: hasMatchingVariants,
            mobileVariantsExpanded: false
          });
        }
      }
  }

  componentDidMount() {
      let that = this;

      this.registerEventHubListener('updateTrackInfo', function(data) {
          if (data[0].id !== that.props.id) {
              that.setState({
                  playing : false
              });
          }
      });

      this.registerEventHubListener('updateTrackVariantInfo', function(data) {
        if (data[0].id !== that.props.id) {
            that.setState({
                playing : false
            });
        }
    });


      this.registerEventHubListener('audioPlayerPlay', function(data) {
          if (data[0].id === that.props.id) {
              that.setState({
                  playing : true
              });
          }
      });


      this.registerEventHubListener('audioPlayerStop', function() {
          if (that.state.playing) {
              that.setState({
                  playing : false
              });
          }
      });

      this.registerEventHubListener('audioPlayerEnded', function() {
          if (that.state.playing) {
              that.setState({
                  playing : false
              });
          }
      });
  }

  componentWillUnmount() {
      if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
        this.eventHubListeners = [];
        return;
      }

      this.eventHubListeners.forEach(function(listener) {
        legacyEventHub.off(listener.eventName, listener.handler);
      });
      this.eventHubListeners = [];
  }

  registerEventHubListener(eventName, handler) {
      legacyEventHub.on(eventName, handler);
      this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  trackingPayload(basePayload) {
    return withRankingPayload(basePayload, this.props);
  }

  handleClick(e) {
    e.preventDefault();
    legacyEventHub.trigger('playTrack', this.props.id, this.props);
    legacyEventHub.trigger('updateTrackInfo', this.props);

    this.setState({
      playing: !this.state.playing
    });
  }

  handleLayoutDownloadClick(e) {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    this.triggerDemoDownload();

    if (typeof confetti !== 'undefined') {
      let rect = e.target.getBoundingClientRect();
      console.log(rect.top, rect.right, rect.bottom, rect.left);

      confetti({
        particleCount: 200,
        startVelocity: 20,
        angle: 90,
        spread: 60,
        origin: {
          x: (rect.left + 10) / window.innerWidth,
          // since they fall down, start a bit higher than random
          y: (rect.top + 30) / window.innerHeight
        },
        colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
      });
    }
  }

  handleShareClick(e) {
    e.preventDefault();

    if (this.state.displayCopyHint) {
      this.setState({displayCopyHint: false});
    } else {
      if (!this.state.shareTrackingFired) {
        trackCatalogEvent('track_share', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));
      }

      if (navigator.share) {
        // Web Share API is supported
        navigator.share({
          title: (this.props.display_title || this.props.title) + ' | ' + (this.props.locale === 'de' ? 'GEMAfreie Musik auf audiocrowd.net' : 'Royalty-free music on audiocrowd.net'),
          url: this.props.showcaseUrl + '?utm_source=share_link_teaser&utm_medium=referral'
        })
        this.setState({shareTrackingFired: true});
      } else {
        // Fallback
        this.copyToClipboard(this.props.showcaseUrl + '?utm_source=share_link_teaser&utm_medium=referral');
        this.setState({displayCopyHint: true, shareTrackingFired: true}, function() {
          setTimeout(function() {
            this.setState({displayCopyHint: false})
          }.bind(this), 5000)
        });
      }

      if ( typeof confetti !== 'undefined') {
        let rect = e.target.getBoundingClientRect();
        console.log(rect.top, rect.right, rect.bottom, rect.left);

        confetti({
          particleCount: 200,
          startVelocity: 30,
          angle: 90,
          spread: 60,
          shapes: ['circle'],
          origin: {
            x: (rect.left + 10) / window.innerWidth,
            // since they fall down, start a bit higher than random
            y: (rect.top + 20) / window.innerHeight
          },
          colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
        });
      }
    }
  }

  copyToClipboard(str) {
    let el = document.createElement('textarea');
    el.value = str;
    el.setAttribute('readonly', '');
    el.style.position = 'absolute';
    el.style.left = '-9999px';
    document.body.appendChild(el);
    el.select();
    document.execCommand('copy');
    document.body.removeChild(el);
  }

  toggleMobileVariants(e) {
    e.preventDefault();

    this.setState((currentState) => ({
      mobileVariantsExpanded: !currentState.mobileVariantsExpanded
    }));
  }

  toggleMatchingVariants(e) {
    e.preventDefault();

    this.setState((currentState) => ({
      matchingVariantsExpanded: !currentState.matchingVariantsExpanded
    }));
  }

  triggerDemoDownload() {
    if (!this.demoDownloadAllowed()) {
      return;
    }

    let returnTo = encodeURIComponent((window.location.pathname || '/') + (window.location.search || ''));
    let customerSignedIn = (document.body?.getAttribute('data-user-tracking-context') || '').indexOf('customer') === 0;
    let link = document.createElement("a"),
        uri = '/c/tracks/' + this.props.id + '/download_layout?return_to=' + returnTo,
        isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor),
        isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    // If you don't know the name or want to use
    // the webserver default set name = ''

    link.href = uri

    trackCatalogEvent('track_layout_download_intent', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));

    if (customerSignedIn) {
      // logged in
      if (!isChrome && !isFirefox) {
        link.setAttribute('download', '');
      }
    }

    if (customerSignedIn) {
      trackCatalogEvent('track_layout_download', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));
    }

    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  demoDownloadAllowed() {
    return Number(this.props.length || 0) >= MIN_DEMO_DOWNLOAD_LENGTH_SECONDS;
  }

  handlefreeDownloadBuyInShopClick(e) {
    e.preventDefault();
    let win = window.open(this.props.showcaseUrl, '_blank');
    // let win = window.open((this.props.locale === 'de' ? ('http://localhost:3000/tracks/' + this.props.id + '/free_download') : ('http://localhost:3000/tracks/' + this.props.id + '/free_download')), '_blank');
    win.focus();

    console.log('handle buy in shop click');
  }

  handlefreeDownloadAgreeClick(e) {
    e.preventDefault();

    trackCatalogEvent('track_download_free', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));

    let win = window.open((this.props.locale === 'de' ? ('/tracks/' + this.props.id + '/free_download') : ('/tracks/' + this.props.id + '/free_download')), '_blank');
    // let win = window.open((this.props.locale === 'de' ? ('http://localhost:3000/tracks/' + this.props.id + '/free_download') : ('http://localhost:3000/tracks/' + this.props.id + '/free_download')), '_blank');
    win.focus();
  }

  handlefreeDownloadRejectClick(e) {
    e.preventDefault();
    console.log('handle reject click');
  }

  handleNextClick(e) {
      e.preventDefault();
      legacyEventHub.trigger('playTrack', this.props.next_track.id, this.props.next_track);
      legacyEventHub.trigger('updateTrackInfo', this.props.next_track);
      this.setState({
        playing: !this.state.playing
      });
  }

  handlePrevClick(e) {
      e.preventDefault();
      legacyEventHub.trigger('playTrack', this.props.prev_track.id, this.props.prev_track);
      legacyEventHub.trigger('updateTrackInfo', this.props.prev_track);
      this.setState({
          playing: !this.state.playing
      });
  }

  handleFavoriteClick(e) {
      e.preventDefault();

      this.props.handleFavoriteClick(this.props.id);

      if (!this.props.favorited && typeof confetti !== 'undefined') {
        let rect = e.target.getBoundingClientRect();
        console.log(rect.top, rect.right, rect.bottom, rect.left);

        confetti({
          particleCount: 200,
          startVelocity: 30,
          angle: 90,
          spread: 60,
          shapes: ['circle'],
          origin: {
            x: (rect.left + 10) / window.innerWidth,
            // since they fall down, start a bit higher than random
            y: (rect.top + 20) / window.innerHeight
          },
          colors: ['#e97900', '#d77812', '#ffd6aa', '#43ce00', '#63de00', '#a4d08f', '#52489C', '#635b9a', '#baafff']
        });
      }
  }

  handleFreeDownloadClick(e) {
      e.preventDefault();
      this.props.handleFreeDownloadClick(this.props.id);
  }

  handleFreeDownloadDialogClick(e) {
    e.preventDefault();
  }

  handlefreeDownloadRejectClick(e) {
    e.preventDefault();
    legacyEventHub.trigger('closePopupMenus');
  }


  handleTagClick(tagId, e) {
      e.preventDefault();
      legacyEventHub.trigger('trackTagClick', tagId);
  }

  handleGenreClick(genreId, e) {
      e.preventDefault();
      legacyEventHub.trigger('trackGenreClick', genreId);
  }

  handleMoodClick(moodId, e) {
      e.preventDefault();
      legacyEventHub.trigger('trackMoodClick', moodId);
  }

  handleProScopeClick(e) {
      e.preventDefault();
      let includePro = (this.props.royaltyFree === null || this.props.royaltyFree === true) ? 2 : 0;
      legacyEventHub.trigger('trackProScopeClick', { includePro: includePro, track_id: this.props.id });
  }

  handleMouseEnter(e) {
      e.preventDefault();
      this.setState({
          isHovered: true
      });
  }

  handleMouseLeave(e) {
      e.preventDefault();
      this.setState({
          isHovered: false
      });
  }

  handleVariantClick(variantId, trackId, variantTitle, e) {
    e.preventDefault();
    legacyEventHub.trigger('playTrackVariant', variantId, trackId);
    this.setState({
      playing: false
    });
  }

  truncate(text, count){
    return (text.length > count) ? text.substr(0, count-1) + '...' : text;
  }

  updateCart(usageLicenseTypeId, exposurePackId, forFx) {
    let itemId = this.props.id || this.state.data.id,
        i,
        updateUrl;

    if (exposurePackId) {
        updateUrl = "/cart?exposure_pack_id=" + exposurePackId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else if (forFx) {
        updateUrl = "/cart?sound_effect_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    } else {
        updateUrl = "/cart?track_id=" + itemId + "&usage_license_type_id=" + usageLicenseTypeId;
    }

    return requestJson(updateUrl, {
      method: 'POST',
      data: this.trackingPayload({ location: window.location.href })
    }).then(function(data) {

      legacyEventHub.trigger('updateCart', data)

      var cartItems = data.items || data;

      // One click should emit one add_cart event, even if cartItems has duplicates.
      for (i = 0; i < cartItems.length; i += 1) {
          if (cartItems[i].track_id === itemId) {
              trackCatalogEvent('track_add_cart', this.trackingPayload({ track_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href }));
              break;
          } else if (cartItems[i].sound_effect_id === itemId) {
              trackCatalogEvent('sound_effect_add_cart', { sound_effect_id: itemId, usage_license_type_id: usageLicenseTypeId, location: window.location.href });
              break;
          }
      }

      if (typeof fbq === 'function') {
          fbq('track', 'AddToWishlist', {
              content_ids: itemId.toString(),
              content_type: 'product',
          });
      }

    }.bind(this));
  }

  updateProjectLicenseFamily(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRequestData(itemId, projectLicenseSelection, this.trackingPayload({ location: window.location.href }));
    const trackingProps = buildProjectLicenseTrackingProps(itemId, projectLicenseSelection, window.location.href);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function(data) {
      legacyEventHub.trigger('updateCart', data);

      trackCatalogEvent('track_add_cart', this.trackingPayload(trackingProps));
    }.bind(this));
  }

  removeProjectLicenseSelection(projectLicenseSelection) {
    let itemId = this.props.id || this.state.data.id;
    const requestData = buildProjectLicenseCartRemoveRequestData(itemId, projectLicenseSelection);

    if (!requestData) {
      return null;
    }

    return requestJson('/cart', {
      method: 'POST',
      data: requestData
    }).then(function(data) {
      legacyEventHub.trigger('updateCart', data);
    }.bind(this));
  }

  handleCartClick(e) {
      e.preventDefault();

      if (!this.props.showUsageLicenseSelect && this.props.id) {
        trackCatalogEvent('track_open_license_select', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));
      }

      this.props.handleCartClick(this.props.id);
  }

  openTrackDetailsDrawer(e) {
      e.preventDefault();

      this.setState({ showTrackDetailsDrawer: true });
  }

  closeTrackDetailsDrawer(e) {
      if (e) {
        e.preventDefault();
      }

      this.setState({ showTrackDetailsDrawer: false });
  }

  openSimilarTracksDrawer(e) {
      e.preventDefault();

      trackCatalogEvent('track_show_similar_tracks', this.trackingPayload({ track_id: this.props.id, location: window.location.href }));

      this.setState({ showSimilarTracksDrawer: true });
  }

  closeSimilarTracksDrawer(e) {
      if (e) {
        e.preventDefault();
      }

      this.setState({ showSimilarTracksDrawer: false });
  }

  handleUsageLicenseTypeSelectClose(e) {
      e.preventDefault();

      if (typeof this.props.handleUsageLicenseTypeSelectClose === 'function') {
        this.props.handleUsageLicenseTypeSelectClose(this.props.id);
        return;
      }

      this.props.handleCartClick(this.props.id);
  }

  getSelectedUsageLicenseTypeIds() {
      let ids = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
          cart_items = this.props.cart_items;

      cart_items.forEach(function(element) {
          if (element.track_id === trackId) {
              ids.push(element.usage_license_type_id);
          }
      });

      return ids;
  }

  getSelectedProjectLicenseFamilyKeys() {
      let familyKeys = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
          cart_items = this.props.cart_items;

      cart_items.forEach(function(element) {
          if (element.track_id === trackId && element.project_license_family_key) {
              familyKeys.push(element.project_license_family_key);
          }
      });

      return familyKeys;
  }

  getSelectedProjectLicenseSelections() {
      let selections = [],
          that = this,
          trackId = this.props.id || that.state.data.id,
          cart_items = this.props.cart_items;

      cart_items.forEach(function(element) {
          if (element.track_id === trackId && element.project_license_family_key) {
              selections.push({
                  familyKey: element.project_license_family_key,
                  usageLicenseTypeId: element.usage_license_type_id,
                  selectedOptionKeys: element.project_license_option_keys,
                  customerProjectLicensePresetId: element.customer_project_license_preset_id,
                  customerEventLicensePresetId: element.customer_event_license_preset_id,
                  projectLicensePresetName: element.project_license_preset_name
              });
          }
      });

      return selections;
  }

  trackDetailsHref() {
      if (!this.props.showcaseUrl) {
        return '#';
      }

      try {
        const baseOrigin = typeof window !== 'undefined' && window.location && window.location.origin ? window.location.origin : 'http://localhost';
        const parsedUrl = new URL(this.props.showcaseUrl, baseOrigin);
        const normalizedPath = `${parsedUrl.pathname}${parsedUrl.search}${parsedUrl.hash}`;

        return normalizedPath || this.props.showcaseUrl;
      } catch (error) {
        return this.props.showcaseUrl;
      }
  }

  gemaNavigatorHref() {
      let basePath = this.props.gemaNavigatorPath || (this.props.locale === 'en' ? '/service/music-licensing-navigator/start' : '/service/gema-navigator/start');
      let licenseHint = (this.props.royaltyFree === null || this.props.royaltyFree === true) ? 'gemafrei' : 'pro';
      let query = new URLSearchParams({
        source: 'track-card',
        license_hint: licenseHint,
        track_id: String(this.props.id)
      });

      return basePath + (basePath.indexOf('?') === -1 ? '?' : '&') + query.toString();
  }

  normalizeLengthFilterValue(value) {
      if (Number.isInteger(value)) {
        return value;
      }

      let parsedValue = parseInt(value, 10);
      return Number.isNaN(parsedValue) ? '' : parsedValue;
  }

  variantLengthForProps(variant, props = this.props) {
      return variant.length_seconds || variant.length || props.length;
  }

  variantLoopValue(variant) {
      return variant && (variant.loop === true || variant.loop === 1 || variant.loop === '1');
  }

  buildVariantMatchCriteria(props = this.props) {
      let minLength = this.normalizeLengthFilterValue(props.minLengthFilter);
      let maxLength = this.normalizeLengthFilterValue(props.maxLengthFilter);
      let loopFilter = this.normalizeLengthFilterValue(props.loopFilter);
      let criteria = [];

      if (minLength > 0 || maxLength > 0) {
        let label;

        if (minLength > 0 && maxLength > 0) {
          label = this.props.locale === 'de'
            ? ('länger als ' + minLength + ' Sekunden und kürzer als ' + maxLength + ' Sekunden')
            : ('longer than ' + minLength + ' seconds and shorter than ' + maxLength + ' seconds');
        } else if (minLength > 0) {
          label = this.props.locale === 'de'
            ? ('länger als ' + minLength + ' Sekunden')
            : ('longer than ' + minLength + ' seconds');
        } else {
          label = this.props.locale === 'de'
            ? ('kürzer als ' + maxLength + ' Sekunden')
            : ('shorter than ' + maxLength + ' seconds');
        }

        criteria.push({
          key: 'length',
          label: label,
          matches: function(variant) {
            let variantLength = this.variantLengthForProps(variant, props);

            if (minLength > 0 && variantLength < minLength) {
              return false;
            }

            if (maxLength > 0 && variantLength > maxLength) {
              return false;
            }

            return true;
          }.bind(this)
        });
      }

      if (loopFilter === 1 || loopFilter === 2) {
        let requireLoop = loopFilter === 1;

        criteria.push({
          key: 'loop',
          label: this.props.locale === 'de'
            ? (requireLoop ? 'Loop' : 'Kein Loop')
            : (requireLoop ? 'Loop' : 'No loop'),
          matches: function(variant) {
            let isLoopVariant = this.variantLoopValue(variant);
            return requireLoop ? isLoopVariant : !isLoopVariant;
          }.bind(this)
        });
      }

      return criteria;
  }

  matchingVariantsForProps(props = this.props) {
      let criteria = this.buildVariantMatchCriteria(props);
      let variants = Array.isArray(props.track_variants) ? props.track_variants : [];

      if (criteria.length === 0) {
        return [];
      }

      return variants.filter(function(variant) {
        return criteria.every(function(criterion) {
          return criterion.matches(variant);
        });
      }.bind(this));
  }

  matchingVariantsLabel(criteria = this.buildVariantMatchCriteria()) {
      if (!Array.isArray(criteria) || criteria.length === 0) {
        return this.props.locale === 'de' ? 'Passende Varianten' : 'Matching variants';
      }

      let criteriaLabel = criteria.map(function(criterion) {
        return criterion.label;
      }).filter(Boolean).join(', ');

      if (criteriaLabel.length === 0) {
        return this.props.locale === 'de' ? 'Passende Varianten' : 'Matching variants';
      }

      return (this.props.locale === 'de' ? 'Passende Varianten' : 'Matching variants') + ' (' + criteriaLabel + ')';
  }

  renderVariantWaveforms(variants, formatLength, waveformPlayerI18n, sectionClassName = '') {
      if (!Array.isArray(variants) || variants.length === 0) {
        return null;
      }

      let className = sectionClassName.length > 0 ? ('track__variant-waveforms ' + sectionClassName) : 'track__variant-waveforms';

      return (
        <div className={className}>
          {variants.map(function(variant) {
            let variantLength = this.variantLengthForProps(variant);

            return (
              <TrackWaveformPlayer
                key={'track_variant_waveform_' + sectionClassName + '_' + variant.id}
                trackId={this.props.id}
                trackVariantId={variant.id}
                title={variant.title}
                className='track-waveform-player--compact track__variant-waveform-player'
                waveformInactiveUrl={variant.waveform_loaded || variant.waveform_inactive}
                waveformPlayedUrl={variant.waveform_inactive || variant.waveform_played}
                durationLabel={formatLength(variantLength)}
                durationSeconds={variantLength}
                i18n={waveformPlayerI18n} />
            );
          }.bind(this))}
        </div>
      );
  }

  render() {
      let classes = classNames({
              'track': true,
              'track--active': this.props.active,
              'track--free': this.props.free,
              'track--purchased': this.props.purchased,
              'track--new': this.props.recently_activated,
              'track--favorited': this.props.favorited,
              'track--license-select-open': this.props.showUsageLicenseSelect,
              'track--search-in-progress': this.props.search_in_progress,
              'track--playing': this.state.playing && !(parseInt(this.props.activeTrackVariantId, 10) > 0),
              'track--variant-playing': this.state.playing && (parseInt(this.props.activeTrackVariantId, 10) > 0),
              'track--mobile-variants-expanded': this.state.mobileVariantsExpanded,
              'track--within-exposure-pack': typeof this.props.exposure_pack !== 'undefined' && this.props.exposure_pack.id
            }),
            cartLink,
            favoriteLink,
            recentlyCreatedLabel,
            purchasedLabel,
            cartLinkIcon,
            usageLicenseTypeSelect,
            trackDetailsDrawer,
            projectAction,
            trackLabels,
            composerInfo,
            proListElement,
            trackStatusLink,
            primaryGenreAction,
            youtubeContentIdTag,
            trackDetailsHref,
            suggestedTopicTags = Array.isArray(this.props.suggestedTopicTags) ? this.props.suggestedTopicTags : [],
            genreItems = [],
            tagItems = [],
            moodItems = [];

      let layoutDownloadLink,
          shareLink,
          freeDownloadDialog,
          copyHint;

      if (this.state.displayCopyHint && !navigator.share) {
        copyHint = <div className="track__copy-hint">
            <div className="track__copy-hint-content">
              <i className='track__copy-hint-icon fa fa-check'></i>
              <span className='track__copy-hint-text'>{this.props.locale === 'de' ? 'Die Track-URL wurde in die Zwischenablage kopiert.' : 'The track URL was copied to your clipboard.'}</span>
            </div>
        </div>;
      }


      if (this.props.showFreeDownloadDialog) {
          freeDownloadDialog = (
            <div className='track__free-download-dialog-bg' onClick={this.handleFreeDownloadDialogClick}>
              <div className='track__free-download-dialog-wrapper'>
                <a href='#' className='track__free-download-dialog-close' title='Close free download dialog' onClick={this.handlefreeDownloadRejectClick}><i className='fa fa-times'></i></a>
                <div className='row'>
                  <div className='col12'>
                    <div className='text-like-h2'><span className='text-primary'>#{this.props.id} - {this.props.display_title || this.props.title}</span> - Free Download starten</div>
                  </div>
                </div>

                <div className='row'>
                  <div className='col7 col12-md-down'>
                    <div className='text-like-h4'>Bitte verlinken und nennen Sie audiocrowd!</div>
                    <ul>

                      <li className='track__free-download-dialog-text'>{this.props.locale === 'de' ? 'Nennen Sie audiocrowd mit Internetadresse https://de.audiocrowd.net in Ihrem Video-Abspann oder Outro!' : 'Name audiocrowd with internet address https://en.audiocrowd.net in your video credits or outro!'}</li>
                      <li className='track__free-download-dialog-text'>
                        {this.props.locale === 'de' ? 'Bitte denken Sie daran, audiocrowd mit einem Link als Quelle anzugeben!' : 'Please remember to mention audiocrowd with a link as source!'}
                      </li>
                      <li className='track__free-download-dialog-text'>{this.props.locale === 'de' ? 'Ist eine Verlinkung nicht möglich, ist der Einsatz der kostenlosen Musik nicht gestattet.' : 'If a link is not possible, the use of free music is not permitted.'}</li>
                    </ul>
                  </div>
                  <div className='col5 col12-md-down'>
                    <strong>Beispiel HTML-Code:</strong>
                    <br></br>
                    <textarea rows='4' value={this.props.locale === 'de' ? "<a href='https://de.audiocrowd.net' target='_blank' title='GEMAfreie Musik von audiocrowd'>GEMAfreie Musik von audiocrowd</a>" : "<a href='https://en.audiocrowd.net' target='_blank' title='Royalty-free music from audiocrowd'>Royalty-free music from audiocrowd</a>"}></textarea>
                    <br></br>
                    <div className='text-like-h4'>Lieber ohne Verlinkung nutzen?</div>
                    <p className='track__free-download-dialog-text'>
                      {this.props.locale === 'de' ? 'Möchten Sie keinen Link setzen? Dann können Sie den Musiktitel einfach im Shop lizenzieren.' : "You don't want to set a link? Then you can simply license the music title in the shop."}
                    </p>
                  </div>
                </div>
                <div className='row'>
                  <div className='col7 col12-md-down margin-bottom20-md-down'>
                    <a href='#' className='button button--full' onClick={this.handlefreeDownloadAgreeClick}>Ja, ich setze einen Link!</a>
                  </div>
                  <div className='col5 col12-md-down'>
                    <a href={this.props.showcaseUrl} className='button button--ghost button--full' target='_blank' onClick={this.handlefreeDownloadBuyInShopClick}>{this.props.locale === 'de' ? 'Zum Shop' : 'To shop'}</a>
                  </div>
                </div>
              </div>
            </div>
          )
      }

      trackDetailsHref = this.trackDetailsHref();

      if (!this.props.exposurePackMode) {
        if (!this.props.freeMode) {
            if (this.demoDownloadAllowed()) {
            layoutDownloadLink = <a className="track__layout-download" onClick={this.handleLayoutDownloadClick} title="Layout-Download">
                <i className='fa fa-download'></i>
                <span className='track__download-link-label'>Demo</span>
                {/* <i className="fa fa-download"></i><span className="track__layout-download-label">{this.props.layout_download}</span> */}
            </a>;
            } else {
            layoutDownloadLink = <span className="track__layout-download track__layout-download--disabled" title="Layout-Download deaktiviert" aria-disabled="true">
                <i className='fa fa-download'></i>
                <span className='track__download-link-label'>Demo</span>
            </span>;
            }
        } else {
            layoutDownloadLink = <span className="track__free-download" title="Free-Download" onClick={this.handleFreeDownloadClick}>
  
                <i className='fa fa-download'></i>
                <span className='track__free-download-link-label'>Download</span>
                {/* <i className="fa fa-download"></i><span className="track__layout-download-label">{this.props.layout_download}</span> */}
            </span>;
        }
      }

      if (!this.props.exposurePackMode) {
        shareLink = (
          <a className="track__share" onClick={this.handleShareClick} title="Share this track">
                <i className='fa fa-share-alt'></i>
                <span className='track__share-link-label'>{this.props.locale === 'de' ? 'Teilen' : 'share'}</span>
                {/* <i className="fa fa-download"></i><span className="track__layout-download-label">{this.props.layout_download}</span> */}
            </a>);
      }

      let formatLength = function(length) {
          let minutes = Math.floor(length / 60);
          let seconds = length % 60;

          if (minutes < 10) {
              minutes = "0" + minutes;
          }

          if (seconds < 10) {
              seconds = "0" + seconds;
          }

          return minutes + ':' + seconds;
      };

      let summaryGridClassName = 'track__summary-grid';
      let hideTagLinks = this.props.hideTagLinks === true;
      let variantCount = this.props.track_variants.length;
      let variantLabel = this.props.locale === 'de' ?
        (variantCount + ' ' + (variantCount === 1 ? 'Track-Variante' : 'Track-Varianten')) :
        (variantCount + ' ' + (variantCount === 1 ? 'Track variant' : 'Track variants'));
      let waveformPlayerI18n = {
        play: this.props.locale === 'de' ? 'Track-Vorschau starten' : 'Play track preview',
        pause: this.props.locale === 'de' ? 'Track-Vorschau pausieren' : 'Pause track preview',
        seek: this.props.locale === 'de' ? 'In der Waveform springen' : 'Seek within waveform'
      };

      let variantToggleButton;
      let matchingVariantToggleButton = null;
      let matchingVariantWaveforms = null;
      let mainWaveformPlayer;
      let trackVariantWaveforms = null;
      let suggestedTopicLinks;
      let energyIndicator;
      let durationLabel = formatLength(this.props.length);
      let energyPercent = energyPercentFromTrack(this.props);
      let energyBarCount = energyBarCountFromPercent(energyPercent);
      let variantMatchCriteria = this.buildVariantMatchCriteria();
      let matchingVariants = this.matchingVariantsForProps();
      let showMatchingVariantsSection = matchingVariants.length > 0;

      if (variantCount > 0 && showMatchingVariantsSection) {
        matchingVariantToggleButton = (
          <button
            type='button'
            className='track__variants-toggle track__variants-toggle--inline'
            aria-expanded={this.state.matchingVariantsExpanded}
            onClick={this.toggleMatchingVariants}>
            <span className='track__variants-toggle-text'>{this.matchingVariantsLabel(variantMatchCriteria)} ({matchingVariants.length})</span>
            <span className='track__variants-toggle-icon'>
              <i className={this.state.matchingVariantsExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
            </span>
          </button>
        );

        variantToggleButton = (
          <button
            type='button'
            className='track__variants-toggle track__variants-toggle--inline'
            aria-expanded={this.state.mobileVariantsExpanded}
            onClick={this.toggleMobileVariants}>
            <span className='track__variants-toggle-text'>{this.props.locale === 'de' ? 'Alle Varianten' : 'All variants'} ({variantCount})</span>
            <span className='track__variants-toggle-icon'>
              <i className={this.state.mobileVariantsExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
            </span>
          </button>
        );
      } else if (variantCount > 0) {
        variantToggleButton = (
          <button
            type='button'
            className='track__variants-toggle track__variants-toggle--inline'
            aria-expanded={this.state.mobileVariantsExpanded}
            onClick={this.toggleMobileVariants}>
            <span className='track__variants-toggle-text'>{variantLabel}</span>
            <span className='track__variants-toggle-icon'>
              <i className={this.state.mobileVariantsExpanded ? 'fa fa-chevron-up' : 'fa fa-chevron-down'}></i>
            </span>
          </button>
        );
      }

      mainWaveformPlayer = (
        <TrackWaveformPlayer
          trackId={this.props.id}
          title=''
          className='track-waveform-player--listing track__waveform-player'
          waveformInactiveUrl={this.props.waveform_loaded || this.props.waveform_inactive}
          waveformPlayedUrl={this.props.waveform_inactive || this.props.waveform_played}
          durationLabel={durationLabel}
          durationSeconds={this.props.length}
          i18n={waveformPlayerI18n} />
      );

      if (showMatchingVariantsSection && this.state.matchingVariantsExpanded) {
        matchingVariantWaveforms = this.renderVariantWaveforms(matchingVariants, formatLength, waveformPlayerI18n, 'track__variant-waveforms--matching');
      }

      if (variantCount > 0 && this.state.mobileVariantsExpanded) {
        trackVariantWaveforms = this.renderVariantWaveforms(this.props.track_variants, formatLength, waveformPlayerI18n, 'track__variant-waveforms--all');
      }

      if (this.props.showProTrackBadge) {
        let navigatorTooltip = this.props.gemaNavigatorTooltip || (this.props.locale === 'de' ? 'GEMAfreie oder P.R.O. Musik für Ihr Projekt nutzen?' : 'Use royalty-free or P.R.O. music for your project?');
        let navigatorTooltipId = 'track-status-tooltip-' + this.props.id;

        if (this.props.royaltyFree === null || this.props.royaltyFree === true) {
          trackStatusLink = (
            <span className='track__status-control'>
              <button type='button' className='track__status-badge track__status-badge--royalty-free track__status-badge--link' onClick={this.handleProScopeClick} title={this.props.locale === 'de' ? 'Filter auf Nur GEMAfrei setzen' : 'Filter to royalty-free only'}>
                {this.props.locale === 'de' ? 'GEMAfrei' : 'Royalty free'}
              </button>
              <a className='track__status-info-link' href={this.gemaNavigatorHref()} target='_blank' rel='noopener' title={navigatorTooltip} aria-label={navigatorTooltip} aria-describedby={navigatorTooltipId}>
                <i className='fa fa-question-circle'></i>
                <span className='track__status-tooltip' id={navigatorTooltipId} role='tooltip'>{navigatorTooltip}</span>
              </a>
            </span>
          );
          proListElement = (<li className='track__detail-list-item track__detail-list-item--mobile-hide-meta'>
            <span className="tag" title={this.props.locale === 'de' ? 'Dieser Track ist GEMAfrei, also nicht im Repertoire einer Verwertungsgesellschaft. Bei Nutzung fallen keine zusätzliche Gebühren durch die Verwertungsgesellschaft an.' : 'This track is not part of the repertoire of a collecting society. If used, additional fees will not be charged by a collecting society.'}>
              <span>{(this.props.locale === 'de'  ? 'GEMAfrei' : 'Royalty free')}</span>
            </span>
          </li>);
        } else {
          trackStatusLink = (
            <span className='track__status-control'>
              <button type='button' className='track__status-badge track__status-badge--pro track__status-badge--link' onClick={this.handleProScopeClick} title={this.props.locale === 'de' ? 'Filter auf Alle Titel inkl. PRO setzen' : 'Filter to all tracks incl. PRO'}>
                {this.props.pro_short_name ? 'P.R.O. (' + this.props.pro_short_name + ')' : 'P.R.O.'}
              </button>
              <a className='track__status-info-link' href={this.gemaNavigatorHref()} target='_blank' rel='noopener' title={navigatorTooltip} aria-label={navigatorTooltip} aria-describedby={navigatorTooltipId}>
                <i className='fa fa-question-circle'></i>
                <span className='track__status-tooltip' id={navigatorTooltipId} role='tooltip'>{navigatorTooltip}</span>
              </a>
            </span>
          );
          proListElement = (<li className='track__detail-list-item track__detail-list-item--mobile-hide-meta'>
            <span className="tag" title={this.props.locale === 'de' ? 'Dieser Track ist Repertoire einer Verwertungsgesellschaft. Bei Nutzung fallen je nach Projekt ggf. zusätzliche Gebühren durch die Verwertungsgesellschaft an.' : 'This track is repertoire of a collecting society. If used, additional fees may be charged by the collecting society dependending on the project scope.'}>
              <span>{(this.props.locale === 'de'  ? 'Verwertungsgesellschaft: ' : 'Collecting society: ')} {this.props.pro_short_name}</span>
            </span>
          </li>)
        }
      } else {
        proListElement = null;
      }

      if (!this.props.exposurePackMode) {
        if (this.props.favorited) {
            favoriteLink = <a href='#' onClick={this.handleFavoriteClick} className='track__favorite-link'><i className="fa fa-heart"></i><span className='track__favorite-label'>{this.props.locale === 'de' ? 'gemerkt' : 'remembered'}</span></a>;
        } else {
            favoriteLink = <a href='#' onClick={this.handleFavoriteClick} className='track__favorite-link'><i className="fa fa-heart-o"></i><span className='track__favorite-label'>{this.props.locale === 'de' ? 'merken' : 'remember'}</span></a>;
        }
      }

      if (this.props.recently_activated || this.props.purchased) {
        if (this.props.recently_activated) {
          recentlyCreatedLabel = <span className='track__label track__label--new'>New</span>
        }
        if (this.props.purchased) {
          purchasedLabel = <span className='track__label track__label--purchased'>{this.props.purchaseCount} {this.props.locale === 'de' ? 'x heruntergeladen' : 'x downloaded'}</span>
        }
        trackLabels = <span className="track__labels">{recentlyCreatedLabel} {purchasedLabel}</span>;
      }

      if (this.props.composerName) {
          composerInfo = <span className="track__composer">by <a itemProp="author" className="track__composer-name" href={this.props.composerUrl}>{this.props.composerName}</a></span>;
      } else {
          composerInfo = '';
      }


      if (!hideTagLinks && !this.props.hideItemIdList) {
          genreItems = this.props.genre_id_list.map((genreId) =>
              <li key={'track_' + this.props.id + '_genre_' + genreId} className={'track__detail-list-item ' + (this.props.isActiveItem('genres', genreId) ? 'track__detail-list-item--active' : '')}><a className='tag' itemProp='genre' href='#' onClick={this.handleGenreClick.bind(this, genreId)}>{this.props.getNameFor('genres', genreId)}</a></li>
          );
          tagItems = this.props.tag_id_list.map((tagId) =>
              <li key={'track_' + this.props.id + '_tag_' + tagId} className={'track__detail-list-item ' + (this.props.isActiveItem('tags', tagId) ? 'track__detail-list-item--active' : '')}><a className='tag' itemProp='tag' href='#' onClick={this.handleTagClick.bind(this, tagId)}>{this.props.getNameFor('tags', tagId)}</a></li>
          );
          moodItems = this.props.mood_id_list.map((moodId) =>
              <li key={'track_' + this.props.id + '_mood_' + moodId} className={'track__detail-list-item ' + (this.props.isActiveItem('moods', moodId) ? 'track__detail-list-item--active' : '')}><a className='tag' itemProp='mood' href='#' onClick={this.handleMoodClick.bind(this, moodId)}>{this.props.getNameFor('moods', moodId)}</a></li>
          );
      }

      if (!hideTagLinks && !this.props.hideItemIdList && this.props.genre_id_list.length > 0) {
        let primaryGenreId = this.props.genre_id_list[0];

        primaryGenreAction = (
          <button
            type='button'
            className='track__genre-chip'
            onClick={this.handleGenreClick.bind(this, primaryGenreId)}>
            {this.props.getNameFor('genres', primaryGenreId)}
          </button>
        );
      }

      if (!primaryGenreAction) {
        summaryGridClassName += ' track__summary-grid--without-meta';
      }

      if (this.props.youtube_content_id_enabled) {
        youtubeContentIdTag = (
          <span className='track__meta-tag track__meta-tag--content-id' title={this.props.locale === 'de' ? 'Dieser Track wird bei Einsatz auf YouTube durch ContentID erkannt. Es ist eine einmalige Freigabe seitens des Urhebers notwendig. Dies ist in der Regel innerhalb weniger Stunden erledigt. Weitere Infos entnehmen Sie dem Lizenzdokument, das Sie beim Kauf erhalten.' : 'This track is recognized by ContentID when used on YouTube. A one-time release on the part of the author is necessary. This is usually done within a few hours. For more information, please refer to the license document, which you will receive upon purchase.'}>
            <span>{this.props.locale === 'de' ? 'YouTube ContentID' : 'YouTube ContentID'}</span>
          </span>
        );
      }

      if (!hideTagLinks) {
        suggestedTopicLinks = (
          <div className={'track__topics-column' + (suggestedTopicTags.length === 0 ? ' track__topics-column--empty' : '')} aria-hidden={suggestedTopicTags.length === 0 ? 'true' : undefined}>
            {suggestedTopicTags.map(function(tag, index) {
              let topicLinkClassName = 'track__topic-link' + (this.props.isActiveItem('tags', tag.id) ? ' track__topic-link--active' : '');
              let topicLabel = String(tag.name || '').split('/')[0].trim() || tag.name;

              return (
                <React.Fragment key={'track_topic_suggestion_' + this.props.id + '_' + tag.id}>
                  {index > 0 ? <span className='track__topics-separator'>, </span> : null}
                  <a className={topicLinkClassName} href='#' onClick={this.handleTagClick.bind(this, tag.id)}>{topicLabel}</a>
                </React.Fragment>
              );
            }.bind(this))}
          </div>
        );
      }

      energyIndicator = (
        <div
          className={'track__energy-column' + (energyPercent === null ? ' track__energy-column--empty' : '')}
          aria-hidden={energyPercent === null ? 'true' : undefined}>
          <span className='track__energy-label'>{this.props.locale === 'de' ? 'Energie' : 'Energy'}</span>
          <div className='track__energy-display'>
            <div className='track__energy-meter' aria-hidden='true'>
            {[1, 2, 3].map(function(step) {
              return (
                <span
                  key={'track_energy_step_' + this.props.id + '_' + step}
                  className={'track__energy-meter-step' + (energyBarCount >= step ? ' track__energy-meter-step--active' : '')}></span>
              );
            }.bind(this))}
            </div>
            <span className='track__energy-percent'>{energyPercent}%</span>
          </div>
        </div>
      );

      if (!this.props.freeMode) {
          let cartLinkClass = this.props.inCart ? 'track__action-button-added-to-cart' : 'track__action-button-add-to-cart';
          let cartLinkText = this.props.inCart ? this.props.remove_from_cart : this.props.add_to_cart;
          let cartLinkLabel = this.props.show_download_button ?
            'Download' :
            (this.props.licenseActionLabel || (this.props.locale === 'de' ? 'Lizenz' : 'License'));
          let cartLinkLabelClass = this.props.inCart && !this.props.show_download_button ?
            'track__cart-link-label hide-element' :
            'track__cart-link-label';

          if (this.props.show_download_button) {
              cartLinkIcon = <span className='track__cart-link-icon'><i className="fa fa-download"></i></span>;
          } else if (this.props.inCart) {
              cartLinkIcon = <span className='track__cart-link-icon track__cart-link-icon--in-cart'><i className="track__cart-link-icon-added fa fa-check"></i><i className="fa fa-shopping-cart track__cart-link-icon-cart"></i></span>;
          } else {
              cartLinkIcon = <span className='track__cart-link-icon'><i className="track__cart-link-icon-add fa fa-plus"></i><i className="fa fa-shopping-cart track__cart-link-icon-cart"></i></span>;
          }

          cartLink = <a className={cartLinkClass} href="#" onClick={this.handleCartClick}>
            {cartLinkIcon}
            <span className={cartLinkLabelClass}>{cartLinkLabel}</span>
            <span className='hide-element'>{cartLinkText}</span>
          </a>
      }

      if (this.props.showUsageLicenseSelect && !this.props.freeMode) {
          usageLicenseTypeSelect = (
              <UsageLicenseTypeSelect
              locale={this.props.locale}
              addToCart={this.props.i18n.add_to_cart}
              discount={this.props.discount}
              usageLicenseTypes={this.props.usageLicenseTypes}
              subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
              updateCart={this.updateCart}
              pricing_path={this.props.pricing_path}
              licenseNavigatorPath={this.props.licenseNavigatorPath}
              allowedProjectLicenseFamilyKeys={this.props.allowedProjectLicenseFamilyKeys}
              selectionMode='project_license_family'
              updateProjectLicenseFamily={this.updateProjectLicenseFamily}
              removeProjectLicenseSelection={this.removeProjectLicenseSelection}
              selectedUsageLicenseTypeIds={this.getSelectedUsageLicenseTypeIds()}
              selectedProjectLicenseFamilyKeys={this.getSelectedProjectLicenseFamilyKeys()}
              selectedProjectLicenseSelections={this.getSelectedProjectLicenseSelections()}
              cartItems={this.props.cart_items}
              i18n={this.props.i18n}
              visible={this.props.showUsageLicenseSelect}
              position='overlay'
              show_download_button={this.props.show_download_button}
              handleCartClick={this.handleCartClick}
              onRequestClose={this.handleUsageLicenseTypeSelectClose}
              trackTitle={this.props.display_title || this.props.title}
              trackArtist={this.props.composerName}
              trackImageMarkup={this.props.track_image_markup} />
          );
      }

      trackDetailsDrawer = (
        <TrackDetailsDrawer
          visible={this.state.showTrackDetailsDrawer}
          locale={this.props.locale}
          trackId={this.props.id}
          trackTitle={this.props.display_title || this.props.title}
          projectActionEnabled={this.props.projectActionEnabled}
          trackArtist={this.props.composerName}
          length={this.props.length}
          playing={this.state.playing}
        favorited={this.props.favorited}
        inCart={this.props.inCart}
        freeMode={this.props.freeMode}
        showDownloadButton={this.props.show_download_button}
        activeTrackVariantId={this.props.activeTrackVariantId}
          trackImageMarkup={this.props.track_image_markup}
          royaltyFree={this.props.royaltyFree}
          proShortName={this.props.pro_short_name}
          youtubeContentIdEnabled={this.props.youtube_content_id_enabled}
          energyPercent={energyPercent}
        showcaseUrl={this.props.showcaseUrl}
        trackVariants={this.props.track_variants}
        includedMediaBundles={this.props.included_media_bundles}
        onPlayToggle={this.handleClick}
        onFavoriteToggle={this.handleFavoriteClick}
        onShare={this.handleShareClick}
          onDemo={this.props.freeMode ? this.handleFreeDownloadClick : this.handleLayoutDownloadClick}
          onCart={this.handleCartClick}
          onRequestClose={this.closeTrackDetailsDrawer}
          onVariantSelect={(variant, event) => this.handleVariantClick(variant.id, variant.track_id, variant.title, event)} />
      );

      let similarTracksDrawer = (
        <SimilarTracksDrawer
          visible={this.state.showSimilarTracksDrawer}
          locale={this.props.locale}
          trackTitle={this.props.display_title || this.props.title}
          trackArtist={this.props.composerName}
          length={this.props.length}
          trackImageMarkup={this.props.track_image_markup}
          similarTracksUrl={this.props.similar_tracks_url || ('/api/tracks/' + this.props.id + '/similar?limit=10')}
          cartItems={this.props.cart_items}
          trackFavorites={this.props.trackFavorites}
          usageLicenseTypes={this.props.usageLicenseTypes}
          subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
          licenseNavigatorPath={this.props.licenseNavigatorPath}
          i18n={this.props.i18n}
          onRequestClose={this.closeSimilarTracksDrawer} />
      );

      projectAction = (
        <ProjectAddTo
          trackId={this.props.id}
          trackTitle={this.props.display_title || this.props.title}
          trackVariants={this.props.track_variants}
          locale={this.props.locale}
          enabled={this.props.projectActionEnabled}
        />
      );


      return (
        <div
          ref={this.props.impressionRef}
          className={classes}
          id={'track-' + this.props.id}
          data-track-id={this.props.id}
          data-ranking-position={this.props.ranking_position}
          data-ranking-page-position={this.props.ranking_page_position}
          data-is-exploration-lane={this.props.is_exploration_lane}
          onMouseEnter={this.handleMouseEnter}
          onMouseLeave={this.handleMouseLeave}
          itemScope
          itemType='https://schema.org/CreativeWork'>
          <span itemProp="copyrightHolder" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
          <span itemProp="publisher" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
          <span itemProp="provider" itemType="https://schema.org/Organization" itemScope="" className="hide-element"><span itemProp="name">audiocrowd GmbH</span></span>
          <meta itemProp="isFamilyFriendly" content="true" />
          <meta itemProp="copyrightYear" content={this.props.copyrightYear}></meta>
          <div className={'track__card ' + (hideTagLinks ? 'track__card--tag-links-hidden' : 'track__card--with-topics')}>
            <div className='track__media-column'>
              <div className='track__play-icon' onClick={this.handleClick}>
                <i className={(this.state.playing && !(parseInt(this.props.activeTrackVariantId, 10) > 0)) ? 'fa fa-pause' : 'fa fa-play' } />
                <div className='track__image' dangerouslySetInnerHTML={{__html: this.props.track_image_markup}}></div>
              </div>
            </div>
            <div className='track__summary'>
              <div className={summaryGridClassName}>
                <div className='track__identity'>
                  <div className='track__identity-topline'>
                    <span className='track__id-line'>#{this.props.id}</span>
                  </div>
                  <a className="track__title" href={trackDetailsHref} itemProp="url" title={this.props.display_title || this.props.title}>
                    <span itemProp="name" className="track__title-value">{this.props.exposurePackMode ? (this.props.publicPerformanceTitle || this.props.display_title || this.props.title) : (this.props.display_title || this.props.title)}</span>
                  </a>
                  {trackLabels}
                  {composerInfo}
                  {youtubeContentIdTag}
                  {trackStatusLink}
                </div>
                <div className='track__playback-column'>
                  <div className='track__waveform'>{React.cloneElement(mainWaveformPlayer, { showPlayButton: false })}</div>
                  {matchingVariantToggleButton}
                  {matchingVariantWaveforms}
                  {variantToggleButton}
                  {trackVariantWaveforms}
                </div>
                {primaryGenreAction ? (
                  <div className='track__meta-column'>
                    {primaryGenreAction}
                  </div>
                ) : null}
              </div>
            </div>
            {suggestedTopicLinks}
            {energyIndicator}
            <div className="track__actions">
              {favoriteLink}
              {projectAction}
              {layoutDownloadLink}
              <button type='button' className='track__similar-trigger' onClick={this.openSimilarTracksDrawer} aria-label={this.props.i18n.similar_tracks || (this.props.locale === 'de' ? 'Ähnliche Titel' : 'Similar tracks')}>
                <i className='fa fa-rss'></i>
                <span className='track__similar-link-label'>{this.props.i18n.similar_tracks || (this.props.locale === 'de' ? 'Ähnliche Titel' : 'Similar tracks')}</span>
              </button>
              {shareLink}
              {copyHint}
              <div className={(this.props.free && this.props.freeMode) || (this.props.hideAddToCart) ? 'hide-element' : 'track__cart-link'}>
                {cartLink}
              </div>
              <button type='button' className='track__more-details' onClick={this.openTrackDetailsDrawer} aria-label={this.props.locale === 'de' ? 'Weitere Aktionen öffnen' : 'Open more actions'}>
                <i className='fa fa-ellipsis-v'></i>
                <span className='track__more-details-label'>{this.props.locale === 'de' ? 'Mehr' : 'More'}</span>
              </button>
            </div>
          </div>
          {freeDownloadDialog}
          {usageLicenseTypeSelect}
          {trackDetailsDrawer}
          {similarTracksDrawer}
          {hideTagLinks ? null : (
            <div className="track__details">
              <ul className='track__details-list'>
                {tagItems}
                {moodItems}
                {genreItems}
                {/* <li className='track__detail-list-item'>
                  <a className="tag" href={this.props.similar_tracks_url} target="_blank" title={this.props.i18n.similar_tracks + ' ' + this.props.title}>
                    <i className="fa fa-share-alt track__similar-link-icon"></i>
                    <span className='track__similar-link-text'>{this.props.i18n.similar_tracks}</span>
                  </a>
                </li>
                <li className='track__detail-list-item'>
                  <a itemProp="url" className="tag"  href={this.props.showcaseUrl} target="_blank" title={this.props.title}>
                    <i className="fa fa-info-circle"></i>
                    <span className='track__similar-link-text'>{this.props.locale === 'de' ? 'Track-Details' : 'track details'}</span>
                  </a>
                </li> */}
              </ul>
            </div>
          )}
        </div>
      )
  }
};

Track.defaultProps = {
  cart_items : [],
  hideAddToCart: false,
  locale: 'de',
  showProTrackBadge: true
} 

export default Track;
